import styled from "styled-components";

import ButtonIcon from "components/ui-kit/ButtonIcon";
import { Delete as DeleteIcon } from "@mui/icons-material";

const ClearSpecificationsButton = ({ clear = () => { }, show = false }) => show && (
  <FixedRight>
    <ButtonIcon
      icon={<DeleteIcon />}
      colorBg="red"
      onClick={clear}
      width="min-content"
    />
  </FixedRight>
);

const FixedRight = styled.div`
  position: fixed;
  right: 14px;
  bottom: 40px;
  z-index: 200;
`;

export default ClearSpecificationsButton;
